import * as marietta3d from '..';
import * as marietta from '../../marietta';
import { AutoObjRoom, AutoObjWall } from './object';

/*------------------------------------------------------
    * 自動生成クラス定義
    *
    */
export default class AutoBase {
        public appName: string;

        public appVersion: string;

        public appCustom: string;

        public appGrid: string;

        public drawFloor: number;

        public maxFloor: number;

        public scaleObj: marietta3d.AutoGen.Scale;

        // public PartsInfo: Array<AutoObjParts>;
        public Model: marietta3d.AutoGen.ConstructionModel;

        public PlanPnt: marietta3d.AutoGen.utils.RoomPointArray;

        public HeyaList: Array<Array<marietta3d.AutoGen.object.AutoObjRoom>>;

        public WallList: Array<Array<marietta3d.AutoGen.object.AutoObjWall>>;

        public DimensionList: Array<Array<marietta3d.AutoGen.object.AutoObjDimension>>;

        public FittingList: Array<Array<marietta3d.AutoGen.object.AutoObjFitting>>;

        public FurnitureList: Array<Array<marietta3d.AutoGen.object.AutoObjFurniture>>;

        public EquipmentList: Array<Array<marietta3d.AutoGen.object.AutoObjEquipment>>;

        public ExteriorList: Array<marietta3d.AutoGen.object.AutoObjExterior>;

        public StairList: Array<Array<marietta3d.AutoGen.object.AutoObjStair>>;

        public RoofList: Array<Array<marietta3d.AutoGen.object.AutoObjRoof>>;

        public KetaList: Array<Array<marietta3d.AutoGen.object.AutoObjKeta>>;

        public min: marietta.core.Point;

        public max: marietta.core.Point;

        public yukaMenseki: number[];

        public koujiMenseki: number[];

        public genkanhoko: number;

        public maguchi: number;

        public okuyuki: number;

        public roomCount: number;

        public roomType: string;

        public planSizeX: number;

        public planSizeY: number;

        public sysColor: marietta3d.AutoGen.object.AutoColor;

        public sysAutoParts: Array<marietta3d.AutoGen.object.AutoObjParts>;

        public sysFittingDef: Array<marietta3d.AutoGen.object.AutoObjFitDef>;

        public sysFittingHigh: Array<marietta3d.AutoGen.object.AutoObjFitHigh>;

        public siteData: marietta3d.AutoGen.object.AutoObjSite;

        public dimExist: boolean[];

        public reqDim: boolean;

        public baseUrlPath: string;

        public apiUrlPath: string;

        public webcadUrlPath: string;

        public assetsUrlPath: string;

        public assets3dUrlPath: string;

        public fittingSizeListTarget: string;

        public fittingSizeListAll: string;

        public fittingSizeListType: string;

        /*------------------------------------------------------
        * constructor
        *
        */
        constructor() {
          this.appName = 'WebCAD';
          this.appVersion = '1.0.01';
          this.appCustom = '';
          this.appGrid = '0.5';
          this.maxFloor = 3;
          this.drawFloor = 1;
          this.scaleObj = new marietta3d.AutoGen.Scale();
          // this.PartsInfo = new Array() // parts info
          this.Model = new marietta3d.AutoGen.ConstructionModel();
          this.PlanPnt = new marietta3d.AutoGen.utils.RoomPointArray();
          this.HeyaList = [];
          this.WallList = [];
          this.DimensionList = [];
          this.FittingList = [];
          this.FurnitureList = [];
          this.EquipmentList = [];
          this.ExteriorList = [];
          this.StairList = [];
          this.RoofList = [];
          this.KetaList = [];
          this.min = new marietta.core.Point(0, 0, 0);
          this.max = new marietta.core.Point(0, 0, 0);
          this.dimExist = [false, false, false, false];
          this.yukaMenseki = [0.0, 0.0, 0.0, 0.0];
          this.koujiMenseki = [0.0, 0.0, 0.0, 0.0];
          this.roomCount = 0;
          this.roomType = '';
          this.genkanhoko = 0;
          this.maguchi = 0;
          this.okuyuki = 0;
          this.sysColor = new marietta3d.AutoGen.object.AutoColor();
          this.sysAutoParts = [];
          this.sysFittingDef = [];
          this.sysFittingHigh = [];
          this.siteData = new marietta3d.AutoGen.object.AutoObjSite();
          for (let i = 0; i < this.maxFloor; i += 1) {
            this.HeyaList[i] = [];
            this.WallList[i] = [];
            this.DimensionList[i] = [];
            this.FittingList[i] = [];
            this.FurnitureList[i] = [];
            this.EquipmentList[i] = [];
            this.StairList[i] = [];
            this.RoofList[i] = [];
            this.KetaList[i] = [];
          }
          this.fittingSizeListTarget = '';
          this.fittingSizeListAll = '';
          this.fittingSizeListType = '';
        }

        /*------------------------------------------------------
        * 起動URL
        */
        public setWebcadUrl(base: string, webcad: string, api: string, assets:string, assets3d:string) {
          this.baseUrlPath = base;
          this.webcadUrlPath = webcad;
          this.apiUrlPath = api;
          this.assetsUrlPath = assets;
          this.assets3dUrlPath = assets3d;
        }

        /*------------------------------------------------------
        * [File load event] FileReader WebCADデータの読み込み
        */
        public perseXML(xml: string) {
          const parser = new DOMParser();
          this.Initialize();
          const dom = parser.parseFromString(xml, 'text/xml');
          const root = dom.getElementsByTagName('webcad');
          if (root.length > 0) {
            const app = root[0].getElementsByTagName('application');
            if (app.length > 0) {
              const appName = app[0].getElementsByTagName('name');
              if (appName.length > 0) {
                this.appName = appName[0].textContent;
              }
              const appVer = app[0].getElementsByTagName('version');
              if (appVer.length > 0) {
                this.appVersion = appVer[0].textContent;
              }
              const appCustm = app[0].getElementsByTagName('customize');
              if (appCustm.length > 0) {
                this.appCustom = appCustm[0].textContent;
              }
            }
            const plan = root[0].getElementsByTagName('plan');
            const pattr = plan[0].attributes;
            const strModule = pattr.getNamedItem('module').nodeValue;
            const num = Number(strModule);
            this.scaleObj.SetModule(num);

            const grid = pattr.getNamedItem('grid');
            if (grid != null) {
              this.appGrid = grid.nodeValue;
            }

            const param = plan[0].getElementsByTagName('model_param');
            if (param.length > 0) {
              // this.Model.readXML(param);
            }

            const site:any = plan[0].getElementsByTagName('site');
            if (site.length > 0) {
              const siteShape:any = site[0].getElementsByTagName('shape');
              this.readSite(site, siteShape);
            }

            const jimawari = plan[0].getElementsByTagName('roof');
            if (jimawari.length > 0) {
              let nokide = '0';
              let tumade = '0';
              // <material>の<roof>を引っ張ってしまうので、
              for (let i = 0; i < jimawari.length; i += 1) {
                if (jimawari[i].textContent === '') {
                  const rattr = jimawari[i].attributes;
                  const nodeTuma = rattr.getNamedItem('tsuma_de');
                  if (nodeTuma != null) {
                    tumade = nodeTuma.nodeValue;
                  }
                  const nodeNoki = rattr.getNamedItem('noki_de');
                  if (nodeNoki != null) {
                    nokide = nodeNoki.nodeValue;
                  }
                  const itemList:any = jimawari[i].getElementsByTagName('item');
                  this.readJimawari(itemList, nokide, tumade);
                }
              }
            }

            const room = plan[0].getElementsByTagName('room');
            if (room.length > 0) {
              const itemList:any = room[0].getElementsByTagName('item');
              this.readHeya(itemList);
            }

            const fit = plan[0].getElementsByTagName('fitting');
            if (fit.length > 0) {
              const fitList = fit[0].getElementsByTagName('item');
              this.readTategu(fitList);
            }

            const equ = plan[0].getElementsByTagName('equipment');
            if (equ.length > 0) {
              const equList = equ[0].getElementsByTagName('item');
              this.readJyusetu(equList);
            }

            const fur = plan[0].getElementsByTagName('furniture');
            if (fur.length > 0) {
              const furList = fur[0].getElementsByTagName('item');
              this.readKagu(furList);
            }

            const ext = plan[0].getElementsByTagName('exterior');
            if (ext.length > 0) {
              const extList = ext[0].getElementsByTagName('item');
              this.readGaikou(extList);
            }

            const str = plan[0].getElementsByTagName('stair');
            if (str.length > 0) {
              const strList = str[0].getElementsByTagName('item');
              this.readStair(strList);
            }
          }
        }

        /*------------------------------------------------------
        * [File load event] FileReader WebCADデータの読み込み
        */
        public parseJSON(jsonData: any) {
          let json: any;
          if (typeof jsonData === 'object') {
            json = jsonData;
          } else {
            json = JSON.parse(jsonData);
          }
          this.Initialize();
          const app = json.application;
          if (app.length > 0) {
            const appName = app.name;
            if (appName) {
              this.appName = appName;
            }
            const appVer = app.version;
            if (appVer) {
              this.appVersion = appVer;
            }
            const appCustm = app.customize;
            if (appCustm) {
              this.appCustom = appCustm;
            }
          }
          const planData = json.plan;
          const strModule = planData.module;
          const num = Number(strModule);
          this.scaleObj.SetModule(num);
          if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === marietta.webcad.Constants.BUILDING_TYPE_MANSION) {
            this.scaleObj.SetPitch(1000);
          } else {
            this.scaleObj.SetPitch(60);
          }

          const gridData = planData.grid;
          if (gridData != null) {
            this.appGrid = gridData;
          }

          const modelParamData = planData.model_param;
          if (modelParamData != null) {
            this.Model.readJSON(modelParamData);
          }

          const siteData: any = json.plan.site;
          if (siteData) {
            if (siteData.shape.length > 0) {
              const siteShape:any = siteData.shape;
              this.readSite(siteData, siteShape);
            }
          }

          const jimawari = json.plan.roof;
          if (jimawari.length > 0) {
            let nokide = '0';
            let tumade = '0';
            // <material>の<roof>を引っ張ってしまうので、
            for (let i = 0; i < jimawari.length; i += 1) {
              const nodeTuma = jimawari[i].tsuma_de;
              if (nodeTuma != null) {
                tumade = nodeTuma;
              }
              const nodeNoki = jimawari[i].noki_de;
              if (nodeNoki != null) {
                nokide = nodeNoki;
              }
              const itemList:any = jimawari[i].items;
              this.readJimawari(itemList, nokide, tumade);
            }
          }

          const roomData = json.plan.room;
          if (roomData.length > 0) {
            this.readHeya(roomData);
          }

          const fit = json.plan.fitting;
          if (fit.length > 0) {
            this.readTategu(fit);
          }

          const equ = json.plan.equipment;
          if (equ.length > 0) {
            this.readJyusetu(equ);
          }

          const fur = json.plan.furniture;
          if (fur.length > 0) {
            this.readKagu(fur);
          }

          const ext = json.plan.exterior;
          if (ext.length > 0) {
            this.readGaikou(ext);
          }

          const str = json.plan.stair;
          if (str.length > 0) {
            this.readStair(str);
          }
        }

        /*------------------------------------------------------
        * Draw
        *
        */
        public draw() {
          const cnvs: any = window.document.getElementById('c1');
          const ctx = cnvs.getContext('2d');
          this.debugDraw(this.drawFloor, ctx);
        }

        /*------------------------------------------------------
        * Initialize
        *
        */
        public Initialize() {
          this.Model.Init();
          this.InitHeyaList();
          this.InitWallList();
          this.InitFittingList();
          this.InitEquipmentList();
          this.InitFurnitureList();
          this.InitExteriorList();
          this.InitDimensionList();
          this.InitRoofList();
          this.InitKetaList();
          this.InitStairList();
          this.InitSiteData();
          this.min.Init();
          this.max.Init();
          for (let i = 0; i < this.maxFloor; i += 1) {
            this.dimExist[i] = false;
            this.yukaMenseki[i] = 0.0;
            this.koujiMenseki[i] = 0.0;
          }
          this.fittingSizeListTarget = '';
          this.fittingSizeListAll = '';
          this.fittingSizeListType = '';
        }

        /*------------------------------------------------------
        * Initialize View parameta
        *
        */
        public culcScale(ctxW: number, ctxH: number) {
          this.scaleObj.culc(ctxW, ctxH, this.min, this.max);
        }

        /*------------------------------------------------------
        * 部屋の面積
        */
        public Area(rm: marietta3d.AutoGen.object.AutoObjRoom): number {
          let area = rm.points.GetPolyArea();
          const wp = this.scaleObj.WEBCAD_PITCH * this.scaleObj.WEBCAD_PITCH;
          const module = this.scaleObj.module * this.scaleObj.module;
          const mm = 0.001 * 0.001;
          area = area * (module / wp) * mm;
          return area;
        }

        /*------------------------------------------------------
        * 寸法自動生成
        */
        public AutoGenerateDimension(flr: number) {
          const agDim = new marietta3d.AutoGen.AutoDimension(this);
          agDim.AGDimension(flr);
          this.draw();
        }

        /*------------------------------------------------------
        * 部品の情報を返す
        *
        * id: item code  (Ex "fur02_01" )
        *
        * return: 連想配列.
        */
        public autoPartsInfo(id: string): {} {
          for (let i = 0; i < this.sysAutoParts.length; i += 1) {
            if (this.sysAutoParts[i].IsHit(id) === true) {
              const autoParts = this.sysAutoParts[i];
              return {
                id: autoParts.id,
                name: autoParts.name,
                name_en: autoParts.nameEn,
                filename: autoParts.fileName,
                thumbnail: autoParts.thumbnail,
                depth: autoParts.depth,
                high: autoParts.high,
                width: autoParts.width,
                color: autoParts.color,
              };
            }
          }
          return null;
        }

        /*------------------------------------------------------
        * 部品の選択肢の数を返す
        *
        * id: item code  (Ex "fur02_01" )
        */
        public alternativeCount(id: string): number {
          for (let i = 0; i < this.sysAutoParts.length; i += 1) {
            if (this.sysAutoParts[i].IsHit(id) === true) {
              return this.sysAutoParts[i].alternat.length;
            }
          }
          return 0;
        }

        /*------------------------------------------------------
        * 部品の選択肢の配列を返す
        *
        * id: item code  (Ex "fur02_01" )
        *
        * return: Array of AutoParts
        */
        public alternative(id: string): Array<marietta3d.AutoGen.object.AutoObjParts> {
          for (let i = 0; i < this.sysAutoParts.length; i += 1) {
            if (this.sysAutoParts[i].IsHit(id) === true) {
              return this.sysAutoParts[i].alternat;
            }
          }
          return null;
        }

        /*------------------------------------------------------
        * 部品の選択肢の配列を返す
        *
        * id: item code  (Ex "fur02_01_1" )
        *
        * return: AutoParts
        */
        public alternativeId(id: string): { itemId: string, item: marietta3d.AutoGen.object.AutoObjParts, index: number } {
          const itemId = id.substring(0, 8);
          const alternat = this.alternative(itemId);
          if (alternat) {
            const index = alternat.findIndex((alt) => alt.id === id);
            const item = alternat[index];
            return { itemId, item, index };
          }
          return null;
        }

        /*------------------------------------------------------
        * 3D側で部品の選択を変更した場合、Object のコードをid_3Dにセットする
        *
        * id      : item code  (Ex "fur03_02" )
        * index   : index number
        * obj_code: "fur03_02_1"
        *
        * return: Success = true
        */
        public SetSelectObject(id: string, index: number, objCode: string): boolean {
          let ary: any;
          if (id.indexOf('equ') >= 0) {
            ary = this.EquipmentList;
          } else if (id.indexOf('fur') >= 0) {
            ary = this.FurnitureList;
          } else if (id.indexOf('ext') >= 0) {
            ary = null;
          } else if (id.indexOf('str') >= 0) {
            ary = this.StairList;
          } else {
            ary = null;
          }
          if (ary != null) {
            for (let flr = 0; flr < 3; flr += 1) {
              for (let cnt = 0; cnt < ary[flr].length; cnt += 1) {
                const part:any = ary[flr][cnt];
                if ((part.item === id) && (part.index === index)) {
                  part.id_3D = objCode;
                  return true;
                }
              }
            }
          }
          return false;
        }

        /*------------------------------------------------------
        * データをXML文字列として作成する
        */
        public createXML(): string {
          let xml = '<?xml version="1.0" encoding="utf-8"?>\n';
          xml += '<webcad>\n';
          xml += '<application>\n';
          xml += `  <name>${this.appName}</name>\n`;
          xml += `  <version>${this.appVersion}</version>\n`;
          xml += `  <customize>${this.appCustom}</customize>\n`;
          xml += '</application>\n';
          xml += `<plan area="0" grid="0.5" module="${this.scaleObj.module.toString()}">\n`;
          // xml += this.Model.writeXML();
          xml += this.createXMLsite();
          xml += this.createXMLjimawari();
          xml += this.createXMLheya();
          xml += this.createXMLfit();
          xml += this.createXMLequ();
          xml += this.createXMLfun();
          xml += this.createXMLext();
          xml += this.createXMLstr();
          xml += '</plan>\n';
          xml += '</webcad>\n';
          return xml;
        }

        /*------------------------------------------------------
        * [ASP] リクエスト用の部屋データをXML文字列として作成する
        */
        public reqXML2(): string {
          const xmlText = '<webcad></webcad>';
          const parser = new DOMParser();
          const doc = parser.parseFromString(xmlText, 'text/xml');
          const root = doc.querySelector('webcad');

          const nodeApp = doc.createElement('application');
          root.appendChild(nodeApp);

          const nodeAppName = doc.createElement('name');
          nodeApp.appendChild(nodeAppName);
          nodeAppName.textContent = this.appName;

          const nodeAppVer = doc.createElement('version');
          nodeApp.appendChild(nodeAppVer);
          nodeAppVer.textContent = this.appVersion;

          const nodeAppCustm = doc.createElement('customize');
          nodeApp.appendChild(nodeAppCustm);
          nodeAppCustm.textContent = this.appCustom;

          const nodeBaseUrl = doc.createElement('base_url');
          nodeApp.appendChild(nodeBaseUrl);
          nodeBaseUrl.textContent = this.baseUrlPath;

          const nodeWebcadUrl = doc.createElement('webcad_url');
          nodeApp.appendChild(nodeWebcadUrl);
          nodeWebcadUrl.textContent = this.webcadUrlPath;

          const nodeApiUrl = doc.createElement('cadapi_url');
          nodeApp.appendChild(nodeApiUrl);
          nodeApiUrl.textContent = this.apiUrlPath;

          const nodeAssetsUrl = doc.createElement('assets_url');
          nodeApp.appendChild(nodeAssetsUrl);
          nodeAssetsUrl.textContent = this.assetsUrlPath;

          const nodeAssets3dUrl = doc.createElement('assets_3d_url');
          nodeApp.appendChild(nodeAssets3dUrl);
          nodeAssets3dUrl.textContent = this.assets3dUrlPath;

          const nodePlan = doc.createElement('plan');
          root.appendChild(nodePlan);
          nodePlan.setAttribute('area', '0');
          nodePlan.setAttribute('grid', '0.5');
          nodePlan.setAttribute('module', this.scaleObj.module.toString());

          // this.Model.writeXML2(doc, nodePlan);
          this.createXMLsite2(doc, nodePlan);
          this.createXMLjimawari2(doc, nodePlan);
          this.createXMLheya2(doc, nodePlan);
          this.createXMLfit2(doc, nodePlan);
          this.createXMLequ2(doc, nodePlan);
          this.createXMLfun2(doc, nodePlan);
          this.createXMLext2(doc, nodePlan);
          this.createXMLstr2(doc, nodePlan);
          const xmlSerializer = new XMLSerializer();
          let xmlString = '';
          xmlString += xmlSerializer.serializeToString(doc);
          xmlString = `xml=<?xml version="1.0" encoding="utf- 8"?>\n${AutoBase.lintXML(xmlString)}`;
          return xmlString;
        }

        public static lintXML(xml: string): string {
          let spos = 0;
          const ctrl = [];
          ctrl.push(0);
          ctrl.push(-1);
          let rc = '';
          for (let i = 0; i < xml.length; i += 1) {
            if (xml[i] === '<') {
              if (xml[i + 1] === '/') {
                ctrl[0] = i;
                AutoBase.endTag(ctrl, xml);
                rc += AutoBase.newline(ctrl[1]);
              } else {
                ctrl[0] = i;
                rc += AutoBase.newline(ctrl[1]);
                AutoBase.startTag(ctrl, xml);
              }
              [i] = [ctrl[0]];
              rc += xml.substring(spos, i);
              rc += '\n';
              spos = i;
              i -= 1;
            }
          }

          return rc;
        }

        private static newline(indent: number):string {
          let rc = '';
          let i = indent;
          while (i > 0) {
            i -= 1;
            rc += '  ';
          }
          return rc;
        }

        private static startTag(ctrl: Array<number>, xml: string) {
          const ctrlArr = ctrl;
          ctrlArr[1] += 1;
          for (let i = ctrl[0]; i < xml.length; i += 1) {
            if (xml[i] === '>') {
              if (xml[i - 1] === '/') {
                // />
                ctrlArr[1] -= 1;
                ctrlArr[0] = i + 1;
                return;
              }
              // >
              ctrlArr[0] = i + 1;
              AutoBase.endTag(ctrl, xml);
              return;
            }
          }
        }

        private static endTag(ctrl: Array<number>, xml: string) {
          const ctrlArr = ctrl;
          for (let i = ctrl[0]; i < xml.length; i += 1) {
            if (xml[i] === '<') {
              if (xml[i + 1] === '/') {
                // </
                ctrlArr[1] -= 1;
                for (let j = i; j < xml.length; j += 1) {
                  if (xml[j] === '>') {
                    ctrlArr[0] = j + 1;
                    return;
                  }
                }
              } else {
                // <
                ctrlArr[0] = i;
                return;
              }
            }
          }
        }

        /*------------------------------------------------------
        * [ASP] リクエスト用の部屋データをXML文字列として作成する
        */
        public reqXML(): string {
          let xml = 'xml=<?xml version="1.0" encoding="utf-8"?>\n';
          xml += '<webcad>\n';
          xml += '<application>\n';
          xml += `  <name>${this.appName}</name>\n`;
          xml += `  <version>${this.appVersion}</version>\n`;
          xml += `  <customize>${this.appCustom}</customize>\n`;
          /*
            xml += "  <base_url>" + this.baseUrlPath + "</base_url>\n";
            xml += "  <webcad_url>" + this.webcadUrlPath + "</webcad_url>\n";
            xml += "  <cadapi_url>" + this.apiUrlPath + "</cadapi_url>\n";
          */
          xml += `  <assets_url>${this.assetsUrlPath}</assets_url>\n`;
          xml += `  <assets_3d_url>${this.assets3dUrlPath}</assets_3d_url>\n`;

          xml += '</application>\n';

          if (this.fittingSizeListTarget !== '') {
            xml += `<fitting_size_list target="${this.fittingSizeListTarget}" all_list="${this.fittingSizeListAll}" />\n`;
          }
          xml += '<plan area="0"';
          xml += ` grid="${this.appGrid}"`;
          xml += ` module="${this.scaleObj.module.toString()}"`;
          xml += '>\n';
          // xml += this.Model.writeXML();
          xml += this.createXMLsite();
          xml += this.createXMLjimawari();
          xml += this.createXMLheya();
          xml += this.createXMLfit();
          xml += this.createXMLequ();
          xml += this.createXMLfun();
          xml += this.createXMLext();
          xml += this.createXMLstr();
          xml += '</plan>\n';
          xml += '</webcad>\n';
          return xml;
        }

        /*------------------------------------------------------
        * [event] initXML
        */
        /* public initXML(e: any) {
          this.Initialize();
          const xml = e.target.result;
          const parser = new DOMParser();
          const dom = parser.parseFromString(xml, 'text/xml');
          const root = dom.getElementsByTagName('webcad');
          const itemList = root[0].getElementsByTagName('item');
        } */

        /*------------------------------------------------------
        * [event] FileReader 部屋表示色、部品定義の読み込み
        */
        public perseColorXML(e:any) {
          const xml = e.target.result;
          const parser = new DOMParser();
          const dom = parser.parseFromString(xml, 'text/xml');
          const root = dom.getElementsByTagName('Data');
          if (root.length > 0) {
            const attr = root[0].getElementsByTagName('color');
            if (attr.length > 0) {
              // 部屋表示色
              const itemList = attr[0].getElementsByTagName('item');
              for (let i = 0; i < itemList.length; i += 1) {
                const ss = new marietta3d.AutoGen.object.FloorColor();
                ss.readXML(itemList[i]);
                this.sysColor.Add(ss);
              }
            }
            const parts = root[0].getElementsByTagName('parts');
            if (parts.length > 0) {
              // 部品定義
              const partsList = parts[0].getElementsByTagName('item');
              for (let i = 0; i < partsList.length; i += 1) {
                const sp = new marietta3d.AutoGen.object.AutoObjParts();
                sp.readXML(partsList[i]);
                this.sysAutoParts.push(sp);
              }
            }
          }
          // drawPlan(drawFloor);
        }

        /*------------------------------------------------------
        * [event] 寸法の読み込み
        */
        public perseDimension(dimList: any, sc: marietta3d.AutoGen.Scale) {
          const elmDim = dimList.dimension;
          for (let fl = 0; fl < elmDim.length; fl += 1) {
            const rattr = elmDim[fl];
            const flr = Number(rattr.floor);
            const itemList = elmDim[fl].item;
            for (let i = 0; i < itemList.length; i += 1) {
              const sp = new marietta3d.AutoGen.object.AutoObjDimension(flr, null, null, null, null, '');
              sp.readJSON(itemList[i], flr, sc, dimList.building_type);
              sp.culcAngle();
              this.DimensionAdd(sp);
            }
          }
        }
        
      /*------------------------------------------------------
      * [event] 寸法の読み込み
      */
      public perseDimension_(plan_dimension: any, sc: marietta3d.AutoGen.Scale) {
        for (let fl = 0; fl < plan_dimension.length; fl += 1) {
          const rattr = plan_dimension[fl];
          const flr = Number(rattr.floor);
          if (plan_dimension[fl].item == null) return;
          const itemList = plan_dimension[fl].item;
          for (let i = 0; i < itemList.length; i += 1) {
            const sp = new marietta3d.AutoGen.object.AutoObjDimension(flr, null, null, null, null, '');
            sp.readJSON(itemList[i], flr, sc);
            sp.culcAngle();
            this.DimensionAdd(sp);
          }
        }
      }

        /*------------------------------------------------------
        * [event] FileReader マテリアルパラメータの読み込み
        */
        public perseXMLmaterial(e:any) {
          const xml = e.target.result;
          const parser = new DOMParser();
          const dom = parser.parseFromString(xml, 'text/xml');
          const root = dom.getElementsByTagName('material');
          const itemList = root[0].getElementsByTagName('item');
          this.Model.readMaterialList(itemList);
        }

        /*------------------------------------------------------
        * AddPoint
        *
        */
        public AddPoint(p: marietta.core.Point): number {
          let i = 0;
          for (i; i < this.PlanPnt.length; i += 1) {
            if (this.PlanPnt[i].distanceTo(p) < marietta3d.AutoGen.utils.ALMOST_ZERO) {
              return i;
            }
          }
          i = this.PlanPnt.length;
          this.PlanPnt.Add(new marietta.core.Point(p.x, p.y, 0));
          return i;
        }

        /*------------------------------------------------------
        * InitAreaInfo
        *
        */
        public InitAreaInfo() {
          this.roomCount = 0;
          this.roomType = '';
          this.genkanhoko = 0;
          this.maguchi = 0;
          this.okuyuki = 0;
          for (let i = 0; i < this.maxFloor; i += 1) {
            // this.dimExist[i] = false;
            this.yukaMenseki[i] = 0.0;
            this.koujiMenseki[i] = 0.0;
          }
        }

        /*------------------------------------------------------
        * InitHeyaList
        *
        */
        public InitHeyaList() {
          for (let i = 0; i < this.HeyaList.length; i += 1) {
            for (let j = 0; j < this.HeyaList[i].length; j += 1) {
              this.HeyaList[i][j].points.RemoveAll();
              delete this.HeyaList[i][j];
            }
            this.HeyaList[i].splice(0, this.HeyaList[i].length);
          }
        }

        /*------------------------------------------------------
        * InitRoofList
        *
        */
        public InitRoofList() {
          for (let i = 0; i < this.RoofList.length; i += 1) {
            for (let j = 0; j < this.RoofList[i].length; j += 1) {
              this.RoofList[i][j].points.RemoveAll();
              this.RoofList[i][j].arrow.RemoveAll();
              delete this.RoofList[i][j];
            }
            this.RoofList[i].splice(0, this.RoofList[i].length);
          }
        }

        /*------------------------------------------------------
        * InitKetaList
        *
        */
        public InitKetaList() {
          for (let i = 0; i < this.KetaList.length; i += 1) {
            for (let j = 0; j < this.KetaList[i].length; j += 1) {
              this.KetaList[i][j].points.RemoveAll();
              delete this.KetaList[i][j];
            }
            this.KetaList[i].splice(0, this.KetaList[i].length);
          }
        }

        /*------------------------------------------------------
        * InitWallList
        *
        */
        public InitWallList() {
          this.PlanPnt.splice(0, this.PlanPnt.length);
          for (let i = 0; i < this.WallList.length; i += 1) {
            for (let j = 0; j < this.WallList[i].length; j += 1) {
              delete this.WallList[i][j];
            }
            this.WallList[i].splice(0, this.WallList[i].length);
          }
        }

        /*------------------------------------------------------
        * InitFittingList
        *
        */
        public InitFittingList() {
          for (let i = 0; i < this.FittingList.length; i += 1) {
            for (let j = 0; j < this.FittingList[i].length; j += 1) {
              delete this.FittingList[i][j];
            }
            this.FittingList[i].splice(0, this.FittingList[i].length);
          }
        }

        /*------------------------------------------------------
        * InitEquipmentList
        *
        */
        public InitEquipmentList() {
          for (let i = 0; i < this.EquipmentList.length; i += 1) {
            for (let j = 0; j < this.EquipmentList[i].length; j += 1) {
              delete this.EquipmentList[i][j];
            }
            this.EquipmentList[i].splice(0, this.EquipmentList[i].length);
          }
        }

        /*------------------------------------------------------
        * InitStairList
        *
        */
        public InitStairList() {
          for (let i = 0; i < this.StairList.length; i += 1) {
            for (let j = 0; j < this.StairList[i].length; j += 1) {
              delete this.StairList[i][j];
            }
            this.StairList[i].splice(0, this.StairList[i].length);
          }
        }

        /*------------------------------------------------------
        * InitFurnitureList
        *
        */
        public InitFurnitureList() {
          for (let i = 0; i < this.FurnitureList.length; i += 1) {
            for (let j = 0; j < this.FurnitureList[i].length; j += 1) {
              delete this.FurnitureList[i][j];
            }
            this.FurnitureList[i].splice(0, this.FurnitureList[i].length);
          }
        }

        /*------------------------------------------------------
        * InitFurnitureList
        *
        */
        public InitExteriorList() {
          this.ExteriorList.splice(0, this.ExteriorList.length);
        }

        /*------------------------------------------------------
        * InitDimensionList
        *
        */
        public InitDimensionList() {
          for (let i = 0; i < this.DimensionList.length; i += 1) {
            for (let j = 0; j < this.DimensionList[i].length; j += 1) {
              delete this.DimensionList[i][j];
            }
            this.DimensionList[i].splice(0, this.DimensionList[i].length);
            this.dimExist[i] = false;
          }
        }

        /*------------------------------------------------------
        * InitSiteDate
        *
        */
        public InitSiteData() {
          for (let s = 0; s < this.siteData.plgAry.length; s += 1) {
            for (let i = 0; i < this.siteData.plgAry[s].length; i += 1) {
              delete this.siteData.plgAry[s][i];
            }
            this.siteData.plgAry[s].splice(0, this.siteData.plgAry[s].length);
            delete this.siteData.plgAry[s];
          }
          this.siteData.plgAry.splice(0, this.siteData.plgAry.length);
        }

        /*------------------------------------------------------
        * Read Json 敷地
        */
        public readSite(site:any, siteShape:any) {
          if (siteShape.length > 0) {
            this.siteData.readJson(site, siteShape);
          }
        }

        /*------------------------------------------------------
        * Read XML 地回り
        */
        public readJimawari(itemList:any, nokide:any, tumade:any) {
          for (let i = 0; i < itemList.length; i += 1) {
            if (itemList[i].childNodes.length > 0) {
              const keta = new marietta3d.AutoGen.object.AutoObjKeta();
              keta.readJson(itemList[i]);
              if (nokide !== '0') {
                keta.nokide = nokide;
              }
              if (tumade !== '0') {
                keta.tsumade = tumade;
              }
              this.JimawariAdd(keta);
            }
          }
        }

        /*------------------------------------------------------
        * Read XML 部屋
        */
        public readHeya(itemList:any, buildingType:number|null = null): string {
          let n = ' (';
          for (let i = 0; i < itemList.length; i += 1) {
            const heya = new marietta3d.AutoGen.object.AutoObjRoom('', '', 0, marietta.webcad.WebCADGlobal.getGuid(), null, 0);
            n += heya.readJson(itemList[i], buildingType);
            this.HeyaAdd(heya);
          }
          n += ')';
          return n;
        }

        /*------------------------------------------------------
        * Read Json 屋根
        */
        public readRoof(itemList:any, buildingType:number|null = null) {
          for (let i = 0; i < itemList.length; i += 1) {
            const roof = new marietta3d.AutoGen.object.AutoObjRoof();
            roof.readJson(itemList[i], buildingType);
            this.RoofAdd(roof);
          }
        }

        /*------------------------------------------------------
        * Read Json 建具
        */
        public readTategu(itemList:any, buildingType:number|null = null) {
          for (let i = 0; i < itemList.length; i += 1) {
            const fit = new marietta3d.AutoGen.object.AutoObjFitting(0, null, null, '');
            fit.readJson(itemList[i], buildingType);
            this.FittingAdd(fit);
          }
        }

        /*------------------------------------------------------
        * Read Json 住設
        */
        public readJyusetu(itemList:any, buildingType:number|null = null) {
          for (let i = 0; i < itemList.length; i += 1) {
            const equ = new marietta3d.AutoGen.object.AutoObjEquipment(0, marietta.webcad.WebCADGlobal.getGuid(), 1, null, '', 0, 0, 0);
            equ.readJson(itemList[i], this.scaleObj, buildingType);
            this.EquipmentAdd(equ);
          }
        }

        /*------------------------------------------------------
        * Read Json 家具
        */
        public readKagu(itemList:any) {
          for (let i = 0; i < itemList.length; i += 1) {
            const fun = new marietta3d.AutoGen.object.AutoObjFurniture(0, marietta.webcad.WebCADGlobal.getGuid(), 1, null, '', 0, 0, 0);
            fun.readJson(itemList[i], this.scaleObj);
            this.FurnitureAdd(fun);
          }
        }

        /*------------------------------------------------------
        * Read Json 外構
        */
        public readGaikou(itemList:any) {
          for (let i = 0; i < itemList.length; i += 1) {
            const ext = new marietta3d.AutoGen.object.AutoObjExterior(0, marietta.webcad.WebCADGlobal.getGuid(), 1, null, '', 0, 0, 0);
            ext.readJson(itemList[i], this.scaleObj);
            this.ExteriorAdd(ext);
          }
        }

        /*------------------------------------------------------
        * Read XML 階段
        */
        public readStair(itemList:any) {
          for (let i = 0; i < itemList.length; i += 1) {
            const str = new marietta3d.AutoGen.object.AutoObjStair(0, marietta.webcad.WebCADGlobal.getGuid(), 1, null, '', 0, 0, 0, null);
            str.readJson(itemList[i]/* , this.scaleObj */);
            this.StairAdd(str);
          }
          /*
            for (var str of this.StairList[0]) {

                var ary = new marietta3d.AutoGen.utils.RoomPointArray();
                for (var p of str.stroke) {
                    var wp = new Point(p.x, p.y, 0);
                    ary.Add(wp);
                }
                var flr = str.flr;
                var kaidan = new marietta3d.AutoGen.object.AutoObjRoom("rom16_01", "", 1, 0, ary, flr);
                this.InsertHeyaTop(kaidan);
                if ( flr < 3 ) {
                    if ( this.HeyaList[flr].length > 0 ) {
                        var ary2 = new marietta3d.AutoGen.utils.RoomPointArray();
                        for ( var p of str.stroke ) {
                            var wp = new Point( p.x, p.y, 0 );
                            ary2.Add( wp );
                        }
                        var fuki = new marietta3d.AutoGen.object.AutoObjRoom( "rom17_01", "", 1, 0, ary2, flr + 1 );
                        this.InsertHeyaTop( fuki );
                    }
                }
            }
            */
        }

        /*------------------------------------------------------
        * 階に応じて、階の先頭に部屋をインサートする
        */
        public InsertHeyaTop(h1: marietta3d.AutoGen.object.AutoObjRoom) {
          const obj = h1;
          let index = 0;
          let InsIndex = 0;
          if (obj.flr === 1) {
            InsIndex = 1;
            index = 2;
            // １Ｆの部屋 ( flr-1 )
            for (let i = 0; i < this.HeyaList[obj.flr - 1].length; i += 1) {
              const heya = this.HeyaList[obj.flr - 1][i];
              index += 1;
              heya.index = index;
            }
            // ２Ｆの部屋 (flr )
            for (let i = 0; i < this.HeyaList[obj.flr].length; i += 1) {
              const heya = this.HeyaList[obj.flr][i];
              index += 1;
              heya.index = index;
            }
            // ３Ｆの部屋 (flr+1 )
            for (let i = 0; i < this.HeyaList[obj.flr + 1].length; i += 1) {
              const heya = this.HeyaList[obj.flr + 1][i];
              index += 1;
              heya.index = index;
            }
          } else if (obj.flr === 2) {
            // 2Fに追加
            //
            // １Ｆの部屋 ( flr-2 )
            for (let i = 0; i < this.HeyaList[obj.flr - 2].length; i += 1) {
              const heya = this.HeyaList[obj.flr - 2][i];
              if (heya.index > InsIndex) {
                InsIndex = heya.index;
              }
            }
            obj.index = InsIndex + 1;
            index = h1.index + 1;
            // ２Ｆの部屋 (flr -1 )
            for (let i = 0; i < this.HeyaList[obj.flr - 1].length; i += 1) {
              const heya = this.HeyaList[obj.flr - 1][i];
              index += 1;
              heya.index = index;
            }
            // ３Ｆの部屋 (flr )
            for (let i = 0; i < this.HeyaList[obj.flr].length; i += 1) {
              const heya = this.HeyaList[obj.flr][i];
              index += 1;
              heya.index = index;
            }
          } else {
            // 3Fに追加
            //
            // １Ｆの部屋 ( flr-3 )
            for (let i = 0; i < this.HeyaList[obj.flr - 3].length; i += 1) {
              const heya = this.HeyaList[obj.flr - 3][i];
              if (heya.index > InsIndex) {
                InsIndex = heya.index;
              }
            }
            // ２Ｆの部屋 ( flr-2 )
            for (let i = 0; i < this.HeyaList[obj.flr - 2].length; i += 1) {
              const heya = this.HeyaList[obj.flr - 2][i];
              if (heya.index > InsIndex) {
                InsIndex = heya.index;
              }
            }
            obj.index = InsIndex + 1;
            index = h1.index + 1;
            // ３Ｆの部屋 ( flr-1 )
            for (let i = 0; i < this.HeyaList[obj.flr - 1].length; i += 1) {
              const heya = this.HeyaList[obj.flr - 1][i];
              index += 1;
              heya.index = index;
            }
          }
          this.HeyaList[h1.flr - 1].splice(0, 0, h1); /* Index=1 で先頭に追加（すべての領域に負けるようにする） */
        }

        /*------------------------------------------------------
        * Write XML 敷地
        */
        public createXMLsite(): string {
          let xml = '';
          xml += this.siteData.WriteXML();
          return xml;
        }

        /*------------------------------------------------------
        * Write XML 敷地
        */
        public createXMLsite2(doc: Document, plan: Element) {
          this.siteData.WriteXML2(doc, plan);
        }

        /*------------------------------------------------------
        * Write XML 地回り
        */
        public createXMLjimawari(): string {
          let xml = `<jimawari tsuma_de="${this.Model.AutoRoof.tumade}" noki_de="${this.Model.AutoRoof.nokide}" >\n`;
          // const cnt = 1;
          for (let i = 0; i < this.KetaList.length; i += 1) {
            for (let j = 0; j < this.KetaList[i].length; j += 1) {
              xml += this.KetaList[i][j].createXML(/* cnt += 1 */);
            }
          }
          xml += '</jimawari>\n';
          return xml;
        }

        /*------------------------------------------------------
        * Write XML 地回り
        */
        public createXMLjimawari2(doc: Document, plan: Element) {
          const nodeJ = doc.createElement('jimawari');
          plan.appendChild(nodeJ);
          // nodeJ.setAttribute('tsuma_de', this.Model.AutoRoof.tumade);
          nodeJ.setAttribute('noki_de', '0');
          // const cnt = 1;
          for (let i = 0; i < this.KetaList.length; i += 1) {
            for (let j = 0; j < this.KetaList[i].length; j += 1) {
              this.KetaList[i][j].createXML2(doc, nodeJ/* , cnt += 1 */);
            }
          }
        }

        /*------------------------------------------------------
        * Write XML 部屋
        */
        public createXMLheya(): string {
          let xml = '<room>\n';
          // const cnt = 1;
          for (let i = 0; i < this.HeyaList.length; i += 1) {
            for (let j = 0; j < this.HeyaList[i].length; j += 1) {
              xml += this.HeyaList[i][j].createXML(/* cnt += 1 */);
            }
          }
          xml += '</room>\n';
          return xml;
        }

        /*------------------------------------------------------
        * Write XML 部屋
        */
        public createXMLheya2(doc: Document, plan: Element) {
          const nodeRoom = doc.createElement('room');
          plan.appendChild(nodeRoom);
          // const cnt = 1;
          for (let i = 0; i < this.HeyaList.length; i += 1) {
            for (let j = 0; j < this.HeyaList[i].length; j += 1) {
              this.HeyaList[i][j].createXML2(doc, nodeRoom/* , cnt += 1 */);
            }
          }
        }

        /*------------------------------------------------------
        * Write XML 建具
        */
        public createXMLfit(): string {
          let xml = '<fitting>\n';
          let cnt = 1;
          for (let i = 0; i < this.FittingList.length; i += 1) {
            for (let j = 0; j < this.FittingList[i].length; j += 1) {
              xml += this.FittingList[i][j].createXML(cnt += 1);
            }
          }
          xml += '</fitting>\n';
          return xml;
        }

        /*------------------------------------------------------
        * Write XML 建具
        */
        public createXMLfit2(doc: Document, plan: Element) {
          const nodeFit = doc.createElement('fitting');
          plan.appendChild(nodeFit);
          let cnt = 1;
          for (let i = 0; i < this.FittingList.length; i += 1) {
            for (let j = 0; j < this.FittingList[i].length; j += 1) {
              this.FittingList[i][j].createXML2(doc, nodeFit, cnt += 1);
            }
          }
        }

        /*------------------------------------------------------
        * Write XML 住設
        */
        public createXMLequ(): string {
          let xml = '<equipment>\n';
          let cnt = 1;
          for (let i = 0; i < this.EquipmentList.length; i += 1) {
            for (let j = 0; j < this.EquipmentList[i].length; j += 1) {
              xml += this.EquipmentList[i][j].createXML(cnt += 1, this.scaleObj);
            }
          }
          xml += '</equipment>\n';
          return xml;
        }

        /*------------------------------------------------------
        * Write XML 住設
        */
        public createXMLequ2(doc: Document, plan: Element) {
          const nodeEqu = doc.createElement('equipment');
          plan.appendChild(nodeEqu);
          let cnt = 1;
          for (let i = 0; i < this.EquipmentList.length; i += 1) {
            for (let j = 0; j < this.EquipmentList[i].length; j += 1) {
              this.EquipmentList[i][j].createXML2(doc, nodeEqu, cnt += 1, this.scaleObj);
            }
          }
        }

        /*------------------------------------------------------
        * Write XML 家具
        */
        public createXMLfun(): string {
          let xml = '<furniture>\n';
          let cnt = 1;
          for (let i = 0; i < this.FurnitureList.length; i += 1) {
            for (let j = 0; j < this.FurnitureList[i].length; j += 1) {
              xml += this.FurnitureList[i][j].createXML(cnt += 1, this.scaleObj);
            }
          }
          xml += '</furniture>\n';
          return xml;
        }

        /*------------------------------------------------------
        * Write XML 家具
        */
        public createXMLfun2(doc: Document, plan: Element) {
          const nodeFur = doc.createElement('furniture');
          plan.appendChild(nodeFur);
          let cnt = 1;
          for (let i = 0; i < this.FurnitureList.length; i += 1) {
            for (let j = 0; j < this.FurnitureList[i].length; j += 1) {
              this.FurnitureList[i][j].createXML2(doc, nodeFur, cnt += 1, this.scaleObj);
            }
          }
        }

        /*------------------------------------------------------
        * Write XML 外構
        */
        public createXMLext(): string {
          let xml = '<exterior>\n';
          let cnt = 1;
          for (let i = 0; i < this.ExteriorList.length; i += 1) {
            xml += this.ExteriorList[i].createXML(cnt += 1, this.scaleObj);
          }
          xml += '</exterior>\n';
          return xml;
        }

        /*------------------------------------------------------
        * Write XML 外構
        */
        public createXMLext2(doc: Document, plan: Element) {
          const nodeExt = doc.createElement('exterior');
          plan.appendChild(nodeExt);
          let cnt = 1;
          for (let i = 0; i < this.ExteriorList.length; i += 1) {
            this.ExteriorList[i].createXML2(doc, nodeExt, cnt += 1, this.scaleObj);
          }
        }

        /*------------------------------------------------------
        * Write XML 階段部品
        */
        public createXMLstr(): string {
          let xml = '<stair>\n';
          // const cnt = 1;
          for (let i = 0; i < this.StairList.length; i += 1) {
            for (let j = 0; j < this.StairList[i].length; j += 1) {
              xml += this.StairList[i][j].createXML(/* cnt += 1, this.scaleObj */);
            }
          }
          xml += '</stair>';
          return xml;
        }

        /*------------------------------------------------------
        * Write XML 階段部品
        */
        public createXMLstr2(doc: Document, plan: Element) {
          const nodeStr = doc.createElement('stair');
          plan.appendChild(nodeStr);
          // const cnt = 1;
          for (let i = 0; i < this.StairList.length; i += 1) {
            for (let j = 0; j < this.StairList[i].length; j += 1) {
              this.StairList[i][j].createXML2(doc, nodeStr/* , cnt += 1, this.scaleObj */);
            }
          }
        }

        /*------------------------------------------------------
        * HeyaCount
        *
        */
        public HeyaCount(): number {
          let cnt = 0;
          for (let i = 0; i < this.HeyaList.length; i += 1) {
            cnt += this.HeyaList[i].length;
          }
          return cnt;
        }

        /*------------------------------------------------------
        * HeyaAdd
        *
        */
        public HeyaAdd(heya: marietta3d.AutoGen.object.AutoObjRoom) {
          if (heya.IsPorch() === false) {
            if ((this.min.x === 0) && (this.min.y === 0)) {
              heya.points.GetPolygonMinMax(this.min, this.max);
            } else {
              heya.points.GetPolygonMinMaxAdd(this.min, this.max);
            }
          }
          this.HeyaList[heya.flr - 1].push(heya);
        }

        /*------------------------------------------------------
        * RoofAdd
        *
        */
        public RoofAdd(roof: marietta3d.AutoGen.object.AutoObjRoof) {
          this.RoofList[roof.flr - 1].push(roof);
        }

        /*------------------------------------------------------
        * KetaAdd
        *
        */
        public JimawariAdd(keta: marietta3d.AutoGen.object.AutoObjKeta) {
          this.KetaList[keta.flr - 1].push(keta);
        }

        /*------------------------------------------------------
        * Draw to canvas
        */
        public debugDraw(flr: number, ctx: CanvasRenderingContext2D) {
          this.drawFloor = flr;
          const cnvs: any = window.document.getElementById('c1');
          const ctxw = cnvs.width;
          const ctxh = cnvs.height;
          this.culcScale(ctxw, ctxh);
          ctx.clearRect(0, 0, ctxw, ctxh);
          if (this.HeyaCount() > 0) {
            let cnt: number;
            for (cnt = 0; cnt < this.HeyaList[flr - 1].length; cnt += 1) {
              this.HeyaList[flr - 1][cnt].draw(this.scaleObj, ctx, this.sysColor);
            }
            for (cnt = 0; cnt < this.WallList[flr - 1].length; cnt += 1) {
              this.WallList[flr - 1][cnt].draw(this.scaleObj, ctx, this.PlanPnt);
            }
            for (cnt = 0; cnt < this.FittingList[flr - 1].length; cnt += 1) {
              this.FittingList[flr - 1][cnt].draw(this.scaleObj, ctx);
            }
            for (cnt = 0; cnt < this.EquipmentList[flr - 1].length; cnt += 1) {
              this.EquipmentList[flr - 1][cnt].draw(this.scaleObj, ctx);
            }
            for (cnt = 0; cnt < this.FurnitureList[flr - 1].length; cnt += 1) {
              this.FurnitureList[flr - 1][cnt].draw(this.scaleObj, ctx);
            }
            for (cnt = 0; cnt < this.StairList[flr - 1].length; cnt += 1) {
              this.StairList[flr - 1][cnt].draw(this.scaleObj, ctx);
            }
            for (cnt = 0; cnt < this.RoofList[flr - 1].length; cnt += 1) {
              this.RoofList[flr - 1][cnt].draw(this.scaleObj, ctx);
            }
            for (cnt = 0; cnt < this.DimensionList[flr - 1].length; cnt += 1) {
              this.DimensionList[flr - 1][cnt].draw(this.scaleObj, ctx);
            }
          }
        }

        /*------------------------------------------------------
        * Draw to SubWindows canvas
        */
        public debugDrawSubwindow(flr: number, ctx: CanvasRenderingContext2D, width: number, high: number) {
          this.culcScale(width, high);
          ctx.clearRect(0, 0, width, high);
          if (this.HeyaCount() > 0) {
            let cnt: number;
            for (cnt = 0; cnt < this.HeyaList[flr - 1].length; cnt += 1) {
              this.HeyaList[flr - 1][cnt].draw(this.scaleObj, ctx, this.sysColor);
            }
            for (cnt = 0; cnt < this.WallList[flr - 1].length; cnt += 1) {
              this.WallList[flr - 1][cnt].draw(this.scaleObj, ctx, this.PlanPnt);
            }
            for (cnt = 0; cnt < this.FittingList[flr - 1].length; cnt += 1) {
              this.FittingList[flr - 1][cnt].draw(this.scaleObj, ctx);
            }
            for (cnt = 0; cnt < this.EquipmentList[flr - 1].length; cnt += 1) {
              this.EquipmentList[flr - 1][cnt].draw(this.scaleObj, ctx);
            }
            for (cnt = 0; cnt < this.FurnitureList[flr - 1].length; cnt += 1) {
              this.FurnitureList[flr - 1][cnt].draw(this.scaleObj, ctx);
            }
            for (cnt = 0; cnt < this.StairList[flr - 1].length; cnt += 1) {
              this.StairList[flr - 1][cnt].draw(this.scaleObj, ctx);
            }
          }
        }

        /*------------------------------------------------------
        * カット テスト
        *
        function cut_test(x, y, w, h) {
            var wp1 = autoGen.scale.ConvertToWebCAD(new Point(x, y, 0));
            var wp2 = autoGen.scale.ConvertToWebCAD(new Point(x + w, y + h, 0));
            var ary = new marietta3d.AutoGen.utils.RoomPointArray();
            ary.push(new Point(wp1.x, wp1.y, 0));
            ary.push(new Point(wp1.x, wp2.y, 0));
            ary.push(new Point(wp2.x, wp2.y, 0));
            ary.push(new Point(wp2.x, wp1.y, 0));
            var h = new AutoRoom("rom02_01", "mouse", 1, ary, drawFloor)
            for (var i = 0; i < autoGen.HeyaList[drawFloor - 1].length; i += 1) {
                var heya = autoGen.HeyaList[drawFloor - 1][i];
                autoGen.CutKeisan_Main(heya, h);
            }
            autoGen.InitWallList();
            MakeWall();
            drawPlan(drawFloor);
        }
        */

        /*------------------------------------------------------
        * 下の階の階段部屋を吹き抜けとして当階に追加
        */
        public AddKaidan() {
          for (let i = 0; i < this.HeyaList[0].length; i += 1) {
            if (this.HeyaList[0][i].IsStair() === true) {
              const plg = new marietta3d.AutoGen.utils.RoomPointArray();
              plg.CopyFrom(this.HeyaList[0][i].points);
              const hole = new marietta3d.AutoGen.object.AutoObjRoom('rom17_01', '吹抜', 1, marietta.webcad.WebCADGlobal.getGuid(), plg, 2);
              this.HeyaAdd(hole);
            }
          }
        }

        /*------------------------------------------------------
        * すべての部屋から壁を作成
        */
        public MakeWall() {
          const autoHol = new marietta3d.AutoGen.AutoHallway(this);
          this.InitWallList(); // 全壁削除
          for (let flr = 1; flr <= 3; flr += 1) {
            autoHol.CutKeisan(flr); // 全部屋で相互にカット（indexで優先順位を判断）
            autoHol.CutRoukaByKaidan(flr); // 階段で廊下をカット
            this.HeyaPointAdd(flr); // 他の部屋の頂点を、接続する部屋に追加

            for (let i = 0; i < this.HeyaList[flr - 1].length; i += 1) {
              this.MakeWallHeya(this.HeyaList[flr - 1][i]);
            }
          }
        }

        /*------------------------------------------------------
        * 部屋から壁を作成
        */
        public MakeWallHeya(heya: marietta3d.AutoGen.object.AutoObjRoom) {
          if ((heya.IsPorch() === true) || (heya.IsBalcony() === true) || (heya.IsGarage() === true)) {
            return;
          }
          let j: number;
          for (let i = 0; i < heya.points.length; i += 1) {
            j = (i + 1) % heya.points.length;
            const idx1 = this.AddPoint(heya.points[i]);
            const idx2 = this.AddPoint(heya.points[j]);
            const type = heya.points[i].flag;
            if (type > 0) {
              if (this.IsExistWall(heya.flr, idx1, idx2) === false) {
                const ln = heya.points.CopyLine(i);

                ln.GetOffsetEdge(5);
                let mid = ln.GetMidPoint();
                const leftHeya = this.CheckHeya(heya.flr, mid);
                let left = marietta3d.AutoGen.object.HTYPE.UNKNOWN;
                if (leftHeya != null) {
                  left = leftHeya.HeyaType();
                }
                ln.GetOffsetEdge(-10);
                mid = ln.GetMidPoint();
                const rightHeya = this.CheckHeya(heya.flr, mid);
                let right = marietta3d.AutoGen.object.HTYPE.UNKNOWN;
                if (rightHeya != null) {
                  right = rightHeya.HeyaType();
                }
                const w = new marietta3d.AutoGen.object.AutoObjWall(type, left, right, heya.flr, idx1, idx2);
                w.leftHeya = leftHeya;
                w.rightHeya = rightHeya;
                this.WallAdd(w);
              }
            }
          }
        }

        /*------------------------------------------------------
        * planInfo
        */
        /* public planInfo() {
          const genkan = () => {
            let str = '';
            switch (this.genkanhoko) {
              case 1: str = '東'; break;
              case 2: str = '西'; break;
              case 3: str = '南'; break;
              case 4: str = '北'; break;
              default: break;
            }
            return str;
          };

          alert(
            `玄関  : ${genkan()}\n`
                + `部屋数: ${this.roomCount.toString()}${this.roomType}\n`
                + `間口  : ${this.maguchi.toString()}\n`
                + `奥行  : ${this.okuyuki.toString()}\n`
                + `１階床: ${this.yukaMenseki[1].toString()}\n`
                + `２階床: ${this.yukaMenseki[2].toString()}\n`,
          );
        } */

        /*------------------------------------------------------
        * IsExistWall
        *
        */
        public IsExistWall(flr: number, ip1: number, ip2: number): boolean {
          for (let i = 0; i < this.WallList[flr - 1].length; i += 1) {
            if ((this.WallList[flr - 1][i].p1pos === ip1) && (this.WallList[flr - 1][i].p2pos === ip2)) {
              return true; /* Exist same point wall */
            }
            if ((this.WallList[flr - 1][i].p1pos === ip2) && (this.WallList[flr - 1][i].p2pos === ip1)) {
              return true; /* Exist same point wall */
            }
          }
          return false;
        }

        /*------------------------------------------------------
        * WallAdd
        *
        */
        public WallAdd(wall: marietta3d.AutoGen.object.AutoObjWall) {
          if (this.IsExistWall(wall.flr, wall.p1pos, wall.p2pos) === false) {
            this.WallList[wall.flr - 1].push(wall);
          }
        }

        /*------------------------------------------------------
        * Dimensuin Add
        *
        */
        public DimensionAdd(dim: marietta3d.AutoGen.object.AutoObjDimension) {
          this.DimensionList[dim.flr - 1].push(dim);
        }

        /*------------------------------------------------------
        * Fitting Add
        *
        */
        public FittingAdd(fit: marietta3d.AutoGen.object.AutoObjFitting) {
          this.FittingList[fit.flr - 1].push(fit);
        }

        /*------------------------------------------------------
        * Equipment Add
        *
        */
        public EquipmentAdd(equ: marietta3d.AutoGen.object.AutoObjEquipment) {
          this.EquipmentList[equ.flr - 1].push(equ);
        }

        /*------------------------------------------------------
        * Furniture Add
        *
        */
        public FurnitureAdd(fun: marietta3d.AutoGen.object.AutoObjFurniture) {
          this.FurnitureList[fun.flr - 1].push(fun);
        }

        /*------------------------------------------------------
        * Exterior Add
        *
        */
        public ExteriorAdd(ext: marietta3d.AutoGen.object.AutoObjExterior) {
          this.ExteriorList.push(ext);
        }

        /*------------------------------------------------------
        * Stair Add
        *
        */
        public StairAdd(str: marietta3d.AutoGen.object.AutoObjStair) {
          this.StairList[str.flr - 1].push(str);
        }

        /*------------------------------------------------------
        * CheckHeya
        *
        */
        public CheckHeya(flr: number, p: marietta.core.Point): marietta3d.AutoGen.object.AutoObjRoom {
          for (let i = 0; i < this.HeyaList[flr - 1].length; i += 1) {
            if (this.HeyaList[flr - 1][i].points.IsInclude(p) === marietta3d.AutoGen.utils.RC_INCLUDE.INSIDE) {
              return this.HeyaList[flr - 1][i];
            }
          }
          return null;
        }

        /*------------------------------------------------------
        * CheckHeyaType
        *
        */
        public CheckHeyaType(flr: number, p: marietta.core.Point): number {
          for (let i = 0; i < this.HeyaList[flr - 1].length; i += 1) {
            if (this.HeyaList[flr - 1][i].points.IsInclude(p) === marietta3d.AutoGen.utils.RC_INCLUDE.INSIDE) {
              return this.HeyaList[flr - 1][i].HeyaType();
            }
          }
          return marietta3d.AutoGen.object.HTYPE.UNKNOWN;
        }

        /*------------------------------------------------------
        * IsHit
        *
        * 建具 --> 住設 --> 家具 --> 部屋 --> 寸法
        *
        */
        public IsHit(wp: marietta.core.Point): any {
          for (let cnt = 0; cnt < this.FittingList[this.drawFloor - 1].length; cnt += 1) {
            if (this.FittingList[this.drawFloor - 1][cnt].IsHit(wp) === true) {
              return this.FittingList[this.drawFloor - 1][cnt];
            }
          }
          for (let cnt = 0; cnt < this.EquipmentList[this.drawFloor - 1].length; cnt += 1) {
            if (this.EquipmentList[this.drawFloor - 1][cnt].IsHit(wp) === true) {
              return this.EquipmentList[this.drawFloor - 1][cnt];
            }
          }
          for (let cnt = 0; cnt < this.FurnitureList[this.drawFloor - 1].length; cnt += 1) {
            if (this.FurnitureList[this.drawFloor - 1][cnt].IsHit(wp) === true) {
              return this.FurnitureList[this.drawFloor - 1][cnt];
            }
          }
          for (let cnt = 0; cnt < this.HeyaList[this.drawFloor - 1].length; cnt += 1) {
            if (this.HeyaList[this.drawFloor - 1][cnt].IsHit(wp) === true) {
              return this.HeyaList[this.drawFloor - 1][cnt];
            }
          }
          for (let cnt = 0; cnt < this.DimensionList[this.drawFloor - 1].length; cnt += 1) {
            if (this.DimensionList[this.drawFloor - 1][cnt].IsHit(wp) === true) {
              return this.DimensionList[this.drawFloor - 1][cnt];
            }
          }
          return null;
        }

        /*------------------------------------------------------
        * 情報表示
        */
        public ObjectInfo(wp: marietta.core.Point) {
          for (let cnt = 0; cnt < this.FittingList[this.drawFloor - 1].length; cnt += 1) {
            if (this.FittingList[this.drawFloor - 1][cnt].IsHit(wp) === true) {
              const fit = this.FittingList[this.drawFloor - 1][cnt];
              /* window.alert(
                `${'建具\n'
                        + 'Type       : '}${fit.item}\n`,
              ); */
              // alertメソッドが非推奨なため，alertDialogに置き換え
              marietta.webcad.WebCADGlobal.showAlert(`${'建具<br>Type       : '}${fit.item}`);
              return;
            }
          }
          for (let cnt = 0; cnt < this.WallList[this.drawFloor - 1].length; cnt += 1) {
            if (this.WallList[this.drawFloor - 1][cnt].IsHit(wp, this.PlanPnt) === true) {
              const w = this.WallList[this.drawFloor - 1][cnt];
              let wallType: string;
              if ((w.htypeLeft === marietta3d.AutoGen.object.HTYPE.UNKNOWN) || (w.htypeRight === marietta3d.AutoGen.object.HTYPE.UNKNOWN)) {
                if ((w.htypeLeft === marietta3d.AutoGen.object.HTYPE.BALCONY) || (w.htypeRight === marietta3d.AutoGen.object.HTYPE.BALCONY)) {
                  wallType = 'バルコニー腰壁';
                } else {
                  wallType = '外壁';
                }
              } else if (w.OutSide === true) {
                wallType = '外壁';
              } else {
                wallType = '内壁';
              }
              /* window.alert(
                `Type       : ${wallType}\n`
                        + `Left  HType: ${w.htypeName(w.htypeLeft)}\n`
                        + `Right HType: ${w.htypeName(w.htypeRight)}\n`,
              ); */
              // alertメソッドが非推奨なため，alertDialogに置き換え
              marietta.webcad.WebCADGlobal.showAlert(`Type       : ${wallType}<br>Left  HType: ${AutoObjWall.htypeName(w.htypeLeft)}<br>Right HType: ${AutoObjWall.htypeName(w.htypeRight)}`);
              return;
            }
          }
          for (let cnt = 0; cnt < this.EquipmentList[this.drawFloor - 1].length; cnt += 1) {
            if (this.EquipmentList[this.drawFloor - 1][cnt].IsHit(wp) === true) {
              const equ = this.EquipmentList[this.drawFloor - 1][cnt];
              /* window.alert(
                `${'住設\n'
                        + 'Type       : '}${equ.item}\n`,
              ); */
              // alertメソッドが非推奨なため，alertDialogに置き換え
              marietta.webcad.WebCADGlobal.showAlert(`${'住設<br>Type       : '}${equ.item}`);
              return;
            }
          }
          for (let cnt = 0; cnt < this.FurnitureList[this.drawFloor - 1].length; cnt += 1) {
            if (this.FurnitureList[this.drawFloor - 1][cnt].IsHit(wp) === true) {
              const fun = this.FurnitureList[this.drawFloor - 1][cnt];
              /* window.alert(
                `${'家具\n'
                        + 'Type       : '}${fun.item}\n`,
              ); */
              // alertメソッドが非推奨なため，alertDialogに置き換え
              marietta.webcad.WebCADGlobal.showAlert(`${'家具<br>Type       : '}${fun.item}`);
              return;
            }
          }
          for (let cnt = 0; cnt < this.HeyaList[this.drawFloor - 1].length; cnt += 1) {
            if (this.HeyaList[this.drawFloor - 1][cnt].IsHit(wp) === true) {
              const h = this.HeyaList[this.drawFloor - 1][cnt];
              /* window.alert(
                `index    : ${h.index}\n`
                        + `item Code: ${h.item}\n`
                        + `Type     : ${h.htypeName(h.HeyaType())}\n`
                        + `Name     : ${h.name}\n`
                        + `Point cnt: ${h.points.length}\n`,
              ); */
              marietta.webcad.WebCADGlobal.showAlert(`index    : ${h.index}<br>item Code: ${h.item}<br>Type     : ${AutoObjRoom.htypeName(h.HeyaType())}<br>Name     : ${h.name}<br>Point cnt: ${h.points.length}`);
              return;
            }
          }
        }

        /*------------------------------------------------------
        *  囲みの中間に他の部屋のポイントがある場合にそのポイントを追加する
        */
        public HeyaPointAdd(flr: number) {
          const cr = new marietta.core.Point(0, 0, 0);
          for (let hidx1 = 0; hidx1 < this.HeyaList[flr - 1].length; hidx1 += 1) {
            const heya1 = this.HeyaList[flr - 1][hidx1];
            // if (heya1.IsStair()) continue;
            if (!heya1.IsStair()) {
              const hcnt = heya1.points.length;
              const pol = new marietta3d.AutoGen.utils.RoomPointArray();
              for (let i = 0; i < hcnt; i += 1) {
                const ln = heya1.points.GetLine(i);
                const lin = new marietta3d.AutoGen.utils.RoomPointArray();
                lin.AddNew(ln.s);
                lin.AddNew(ln.e);
                const { flag } = ln.s;
                for (let hidx2 = 0; hidx2 < this.HeyaList[flr - 1].length; hidx2 += 1) {
                  // if (hidx1 == hidx2) continue;
                  if (hidx1 !== hidx2) {
                    const heya2 = this.HeyaList[flr - 1][hidx2];
                    const hcnt2 = heya2.points.length;
                    for (let j = 0; j < hcnt2; j += 1) {
                      const ln2 = heya2.points.GetLine(j);
                      if (ln.IsPtOnEdge(ln2.s) === true) { // ln2.sが(ln)に乗っているか
                        if (heya1.points.IsSamePoint(ln2.s) === false) {
                          lin.AddNew(ln2.s);
                        }
                      }
                      if (ln.IsPtOnEdge(ln2.e) === true) { // p4が(p1-p2)に乗っているか
                        if (heya1.points.IsSamePoint(ln2.e) === false) {
                          lin.AddNew(ln2.e);
                        }
                      }
                      if (ln.IntersectionEdge2(ln2, cr)) { // (p3-p4)と(p1-p2)が交点を持つか
                        if (lin.IsSamePoint(cr) === false) {
                          lin.AddNew(cr);
                        }
                      }
                    }
                  }
                }
                lin.PointSort(ln.s, ln.e); // p1-->p2の方向に lin配列をソートする
                for (let j = 0; j < lin.length - 1; j += 1) {
                  const p = lin[j];
                  p.flag = flag;
                  if (pol.IsSamePoint(p) === false) {
                    pol.AddNew(p);
                  }
                }
              }
              for (let j = 0; j < pol.length; j += 1) {
                heya1.points.AddOnlinePoint(pol[j]);
              }
            }
          }
        }

        /*------------------------------------------------------
        * 指定階の壁の中から両サイドの部屋属性で壁を抽出する
        *
        */
        public PickupHeyaType(flr: number, t1: number, t2: number, same: Array<marietta3d.AutoGen.object.AutoObjWall>) {
          for (let cnt = 0; cnt < this.WallList[flr - 1].length; cnt += 1) {
            const w = this.WallList[flr - 1][cnt];
            if ((w.htypeLeft === t1) && (w.htypeRight === t2)) {
              same.push(w);
            }
            if ((w.htypeLeft === t2) && (w.htypeRight === t1)) {
              same.push(w);
            }
          }
        }

        /*------------------------------------------------------
        * 指定階の建具を探す
        *
        */
        public GetOnlineTategu(flr: number, p1: marietta.core.Point, p2: marietta.core.Point): marietta3d.AutoGen.object.AutoObjFitting {
          for (let j = 0; j < this.FittingList[flr - 1].length; j += 1) {
            if (this.FittingList[flr - 1][j].IsOnline(p1, p2) === true) {
              return this.FittingList[flr - 1][j];
            }
          }
          return null;
        }

        /*------------------------------------------------------
        * 指定階の壁の中からp1,p2が乗る壁を探す
        *
        */
        private PickupWall(flr: number, p1: marietta.core.Point, p2: marietta.core.Point): marietta3d.AutoGen.object.AutoObjWall {
          const center: marietta.core.Point = p1.getMidPoint(p2);
          let dist: number = 99999;
          let wd: number = 0;
          let pos: number = -1;
          let w: marietta3d.AutoGen.object.AutoObjWall;
          for (let cnt = 0; cnt < this.WallList[flr - 1].length; cnt += 1) {
            w = this.WallList[flr - 1][cnt];
            const ln = w.CopyLine(this.PlanPnt);
            wd = ln.DistancePtoEdge(center);
            if (wd < dist) {
              dist = wd;
              pos = cnt;
            }
          }
          if (pos !== -1) {
            w = this.WallList[flr - 1][pos];
            return w;
          }
          return null;
        }

        /* ##############################################################
        *
        */
        public AGFittingWall(flr: number, p1: marietta.core.Point, p2: marietta.core.Point): marietta3d.AutoGen.object.AutoObjWall {
          const wl: marietta3d.AutoGen.object.AutoObjWall = this.PickupWall(flr, p1, p2);
          return wl;
        }

        /* ##############################################################
        *
        */
        public AGFittingPoint(wall: marietta3d.AutoGen.object.AutoObjWall, p1: marietta.core.Point, p2: marietta.core.Point): marietta.core.Point {
          const center = p1.getMidPoint(p2);
          const cr = new marietta.core.Point(0, 0, 0);
          const ln = wall.CopyLine(this.PlanPnt);
          ln.VerticalIntersection(center, cr);
          return AutoBase.fixPoint(cr);
        }

        /* ##############################################################
        *
        */
        public AGFittingWidth(wall: marietta3d.AutoGen.object.AutoObjWall, p1: marietta.core.Point, p2: marietta.core.Point): number {
          const cr1 = new marietta.core.Point(0, 0, 0);
          const cr2 = new marietta.core.Point(0, 0, 0);
          const ln = wall.CopyLine(this.PlanPnt);
          ln.VerticalIntersection(p1, cr1);
          ln.VerticalIntersection(p2, cr2);
          const w1 = AutoBase.fixPoint(cr1);
          const w2 = AutoBase.fixPoint(cr2);
          return w1.distanceTo(w2);
        }

        /* ##############################################################
        *
        */
        private static fixPoint(cr: marietta.core.Point): marietta.core.Point {
          const cr2 = new marietta.core.Point(0, 0, 0);
          cr2.x = cr.x;
          if ((cr.x % 3) > 0) {
            if ((cr.x % 3) < 2) {
              cr2.x = Math.floor(cr.x / 3) * 3;
            } else {
              cr2.x = (Math.floor(cr.x / 3) + 1) * 3;
            }
          }
          cr2.y = cr.y;
          if ((cr.y % 3) > 0) {
            if ((cr.y % 3) < 2) {
              cr2.y = Math.floor(cr.y / 3) * 3;
            } else {
              cr2.y = (Math.floor(cr.y / 3) + 1) * 3;
            }
          }
          return cr2;
        }

        /* ##############################################################
        *
        */
        public AGFittingItem(wl: marietta3d.AutoGen.object.AutoObjWall, width: number): string {
          let fit: string = 'fit07_01';
          if (wl != null) {
            wl.CopyLine(this.PlanPnt);
            if ((wl.leftHeya == null) || (wl.rightHeya == null)
                    || ((wl.leftHeya != null) && (wl.leftHeya.IsPorch() === true))
                    || ((wl.rightHeya != null) && (wl.rightHeya.IsPorch() === true))
                    || ((wl.leftHeya != null) && (wl.leftHeya.IsBalcony() === true))
                    || ((wl.rightHeya != null) && (wl.rightHeya.IsBalcony() === true))
                    || ((wl.leftHeya != null) && (wl.leftHeya.IsGarage() === true))
                    || ((wl.rightHeya != null) && (wl.rightHeya.IsGarage() === true))
            ) {
              // 外周の壁
              let heya = null;
              if (wl.rightHeya == null) {
                heya = wl.leftHeya;
              } else if ((wl.leftHeya != null) && ((wl.rightHeya.IsPorch() === true) || (wl.rightHeya.IsBalcony() === true) || (wl.rightHeya.IsGarage() === true))) {
                heya = wl.leftHeya;
              } else {
                heya = wl.rightHeya;
              }
              if (heya.IsBalcony() === true) {
                // バルコニー腰壁
                return ''; // 建具生成はしない
              }
              if (heya.IsEntrance() === true) {
                // 玄関
                if (width > 90) { // width > 1.0P
                  fit = 'fit04_01'; // 両開き
                } else if (width > 60) {
                  fit = 'fit05_01'; // 親子
                } else {
                  fit = 'fit03_01'; // 片開き
                }
              } else if (width > 240) {
                fit = 'fit09_01'; // 引違4枚
              } else if (width > 120) {
                fit = 'fit08_01'; // 引違3枚
              } else if (width > 60) {
                fit = 'fit07_01'; // 引違２枚
              } else if (width > 30) {
                fit = 'fit15_01'; // FIX
              } else {
                fit = 'fit03_01'; // 片開き
              }
            } else {
              // 内部の壁
              if (AutoBase.whatParationRoom(wl, marietta3d.AutoGen.object.HTYPE.ENTRANCE, marietta3d.AutoGen.object.HTYPE.FLORING) === true) {
                fit = 'fit02_01'; // 玄関／洋室＝開口
              }
              if (AutoBase.whatParationRoom(wl, marietta3d.AutoGen.object.HTYPE.ENTRANCE, marietta3d.AutoGen.object.HTYPE.HALLWAY) === true) {
                fit = 'fit02_01'; // 玄関／廊下＝開口
              }
              if (AutoBase.whatParationRoom(wl, marietta3d.AutoGen.object.HTYPE.TOILET, marietta3d.AutoGen.object.HTYPE.HALLWAY) === true) {
                fit = 'fit03_01'; // トイレ／廊下＝片開き
              }
              if (AutoBase.whatParationRoom(wl, marietta3d.AutoGen.object.HTYPE.WASHROOM, marietta3d.AutoGen.object.HTYPE.HALLWAY) === true) {
                fit = 'fit03_01'; // 洗面／廊下＝片開き
              }
              if (AutoBase.whatParationRoom(wl, marietta3d.AutoGen.object.HTYPE.FLORING, marietta3d.AutoGen.object.HTYPE.HALLWAY) === true) {
                fit = 'fit03_01'; // 洋室／廊下＝片開き
              }
              if (AutoBase.whatParationRoom(wl, marietta3d.AutoGen.object.HTYPE.WASITU, marietta3d.AutoGen.object.HTYPE.HALLWAY) === true) {
                fit = 'fit03_01'; // 和室／廊下＝片開き
                if (width > 60) {
                  fit = 'fit07_01'; // 引違２枚
                }
              }
              if (AutoBase.whatParationRoom(wl, marietta3d.AutoGen.object.HTYPE.FLORING, marietta3d.AutoGen.object.HTYPE.FLORING) === true) {
                fit = 'fit03_01'; // 洋室／洋室＝片開き
                if (width > 60) {
                  fit = 'fit07_01'; // 引違２枚
                }
              }
              if (AutoBase.whatParationRoom(wl, marietta3d.AutoGen.object.HTYPE.FLORING, marietta3d.AutoGen.object.HTYPE.LD) === true) {
                fit = 'fit03_01'; // 洋室／LD＝片開き
                if (width > 60) {
                  fit = 'fit07_01'; // 引違２枚
                }
              }
              if (AutoBase.whatParationRoom(wl, marietta3d.AutoGen.object.HTYPE.FLORING, marietta3d.AutoGen.object.HTYPE.LDK) === true) {
                fit = 'fit03_01'; // 洋室／LDK＝片開き
                if (width > 60) {
                  fit = 'fit07_01'; // 引違２枚
                }
              }
              if (AutoBase.whatParationRoom(wl, marietta3d.AutoGen.object.HTYPE.FLORING, marietta3d.AutoGen.object.HTYPE.CLOSET) === true) {
                fit = 'fit11_01'; // 洋室／収納＝折れ戸３枚
                if (width <= 60) {
                  fit = 'fit03_01'; // 片開き
                }
              }
              if (AutoBase.whatParationRoom(wl, marietta3d.AutoGen.object.HTYPE.WASITU, marietta3d.AutoGen.object.HTYPE.CLOSET) === true) {
                fit = 'fit07_01'; // 和室／収納＝引違２枚
                if (width <= 60) {
                  fit = 'fit03_01'; // 片開き
                }
              }
              if (AutoBase.whatParationRoom(wl, marietta3d.AutoGen.object.HTYPE.WASHROOM, marietta3d.AutoGen.object.HTYPE.BATHROOM) === true) {
                fit = 'fit10_01'; // 洗面／浴室＝折れ戸２枚
              }
              if (AutoBase.whatParationRoom(wl, marietta3d.AutoGen.object.HTYPE.HALLWAY, marietta3d.AutoGen.object.HTYPE.BATHROOM) === true) {
                fit = 'fit10_01'; // 廊下／浴室＝折れ戸２枚
              }
              if (AutoBase.whatParationRoom(wl, marietta3d.AutoGen.object.HTYPE.HALLWAY, marietta3d.AutoGen.object.HTYPE.LIVING) === true) {
                fit = 'fit03_01'; // リビング／廊下＝片開き
                if (width > 60) {
                  fit = 'fit07_01'; // 引違２枚
                }
              }
              if (AutoBase.whatParationRoom(wl, marietta3d.AutoGen.object.HTYPE.HALLWAY, marietta3d.AutoGen.object.HTYPE.DINING) === true) {
                fit = 'fit03_01'; // ダイニング／廊下＝片開き
                if (width > 60) {
                  fit = 'fit07_01'; // 引違２枚
                }
              }
              if (AutoBase.whatParationRoom(wl, marietta3d.AutoGen.object.HTYPE.HALLWAY, marietta3d.AutoGen.object.HTYPE.KITCHEN) === true) {
                fit = 'fit03_01'; // キッチン／廊下＝片開き
                if (width > 60) {
                  fit = 'fit07_01'; // 引違２枚
                }
              }
              if (AutoBase.whatParationRoom(wl, marietta3d.AutoGen.object.HTYPE.HALLWAY, marietta3d.AutoGen.object.HTYPE.LD) === true) {
                fit = 'fit03_01'; // LD／廊下＝片開き
                if (width > 60) {
                  fit = 'fit07_01'; // 引違２枚
                }
              }
              if (AutoBase.whatParationRoom(wl, marietta3d.AutoGen.object.HTYPE.HALLWAY, marietta3d.AutoGen.object.HTYPE.LDK) === true) {
                fit = 'fit03_01'; // LDK／廊下＝片開き
                if (width > 60) {
                  fit = 'fit07_01'; // 引違２枚
                }
              }
              if (AutoBase.whatParationRoom(wl, marietta3d.AutoGen.object.HTYPE.LIVING, marietta3d.AutoGen.object.HTYPE.KITCHEN) === true) {
                fit = 'fit02_01'; // リビング／キッチン＝開口
              }
              if (AutoBase.whatParationRoom(wl, marietta3d.AutoGen.object.HTYPE.DINING, marietta3d.AutoGen.object.HTYPE.KITCHEN) === true) {
                fit = 'fit02_01'; // ダイニング／キッチン＝開口
              }
              if (AutoBase.whatParationRoom(wl, marietta3d.AutoGen.object.HTYPE.WASITU, marietta3d.AutoGen.object.HTYPE.TOKONOMA) === true) {
                fit = 'fit02_01'; // 和室／床の間＝開口
              }
              if (AutoBase.whatParationRoom(wl, marietta3d.AutoGen.object.HTYPE.HALLWAY, marietta3d.AutoGen.object.HTYPE.HALLWAY) === true) {
                fit = 'fit02_01'; // 廊下／廊下＝開口
              }
            }
          }
          return fit;
        }

        /* ##############################################################
        *
        */
        private static whatParationRoom(wl: marietta3d.AutoGen.object.AutoObjWall, room1: number, room2: number): boolean {
          if ((wl.leftHeya.HeyaType() === room1) && (wl.rightHeya.HeyaType() === room2)) {
            return true;
          }
          if ((wl.leftHeya.HeyaType() === room2) && (wl.rightHeya.HeyaType() === room1)) {
            return true;
          }
          return false;
        }

        /* ##############################################################
        *
        */
        public AGOuterDoor(flr: number) {
          const same = [];
          /* 玄関 */
          this.PickupHeyaType(flr, marietta3d.AutoGen.object.HTYPE.UNKNOWN, marietta3d.AutoGen.object.HTYPE.ENTRANCE, same);
          this.AutoGeneratorOuterGenkan(flr, same);
          same.splice(0, same.length);

          /* 洋室 */
          this.PickupHeyaType(flr, marietta3d.AutoGen.object.HTYPE.UNKNOWN, marietta3d.AutoGen.object.HTYPE.FLORING, same);
          this.AutoGeneratorOuterFloring(flr, same);
          same.splice(0, same.length);

          /* 和室 */
          this.PickupHeyaType(flr, marietta3d.AutoGen.object.HTYPE.UNKNOWN, marietta3d.AutoGen.object.HTYPE.WASITU, same);
          this.AutoGeneratorOuterFloring(flr, same);
          same.splice(0, same.length);

          /* リビング */
          this.PickupHeyaType(flr, marietta3d.AutoGen.object.HTYPE.UNKNOWN, marietta3d.AutoGen.object.HTYPE.LIVING, same);
          this.AutoGeneratorOuterFloring(flr, same);
          same.splice(0, same.length);

          /* ダイニング */
          this.PickupHeyaType(flr, marietta3d.AutoGen.object.HTYPE.UNKNOWN, marietta3d.AutoGen.object.HTYPE.DINING, same);
          this.AutoGeneratorOuterFloring(flr, same);
          same.splice(0, same.length);

          /* キッチン
            this.PickupHeyaType( flr, HTYPE.UNKNOWN, HTYPE.KITCHEN, same );
            this.AutoGenerator_OuterKitchen( flr, same );
            same.splice( 0, same.length );
            */
          /* トイレ
            this.PickupHeyaType( flr, HTYPE.UNKNOWN, HTYPE.TOILET, same );
            this.AutoGenerator_OuterToilet( flr, same );
            same.splice( 0, same.length );

            // 洗面
            this.PickupHeyaType( flr, HTYPE.UNKNOWN, HTYPE.WASHROOM, same );
            this.AutoGenerator_OuterToilet( flr, same );
            same.splice( 0, same.length );

            // 浴室
            this.PickupHeyaType( flr, HTYPE.UNKNOWN, HTYPE.BATHROOM, same );
            this.AutoGenerator_OuterToilet( flr, same );
            same.splice( 0, same.length );

            // 廊下
            this.PickupHeyaType( flr, HTYPE.UNKNOWN, HTYPE.HALLWAY, same );
            this.AutoGenerator_OuterRouka( flr, same );
            same.splice( 0, same.length );
            */
        }

        public AutoGeneratorOuterGenkan(flr: number, same: Array<marietta3d.AutoGen.object.AutoObjWall>) {
          if (same.length > 0) {
            let len = 0;
            for (let i = 0; i < same.length; i += 1) {
              const w = same[i];
              const p1 = this.PlanPnt[w.p1pos];
              const p2 = this.PlanPnt[w.p2pos];
              if (p1.distanceTo(p2) > len) {
                len = p1.distanceTo(p2);
              }
            }
          }
        }

        public AutoGeneratorOuterFloring(flr: number, same: Array<marietta3d.AutoGen.object.AutoObjWall>) {
          if (same.length > 0) {
            let len = 0;
            let pos = -1;
            for (let i = 0; i < same.length; i += 1) {
              const w = same[i];
              const p1 = this.PlanPnt[w.p1pos];
              const p2 = this.PlanPnt[w.p2pos];
              if (p1.distanceTo(p2) > len) {
                len = p1.distanceTo(p2);
                pos = i;
              }
            }
            if (len >= 120) {
              const wp1 = new marietta.core.Point(0, 0, 0);
              const wp2 = new marietta.core.Point(0, 0, 0);
              const w = same[pos];
              const p1 = this.PlanPnt[w.p1pos];
              const p2 = this.PlanPnt[w.p2pos];
              wp1.copyFrom(p1);
              wp2.copyFrom(p2);
              const ln = new marietta3d.AutoGen.utils.RoomEdge();
              ln.CopyPointFrom(wp1, wp2);
              const s = (len - 120) / 2;
              ln.IncreaseLine(-s, -s);
              // this.FittingAdd( new AutoFitting( flr, ln.s, ln.e, "fit07_01" ) );
            }
          }
        }
}
